<template>
  <div class="home">
    <div class="timer-header">
      <h4>Workout Time:</h4>
      <h2>{{ time2Str(totalTime) }}</h2>
    </div>
    <div class="slider-container">
      <ValueSlider :min="1" :max="20" v-model="exercises">Exercises: {{ exercises }}</ValueSlider>
      <ValueSlider :min="5" :max="200" :step="5" v-model="work">Work: {{ time2Str(work) }}</ValueSlider>
      <ValueSlider :min="5" :max="200" :step="5" v-model="rest">Rest: {{ time2Str(rest) }}</ValueSlider>
    </div>
    <div class="button-container">
      <button @click="startWorkout">Start Workout</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useTimer } from '../composables/useTimer'
import ValueSlider from '@/components/ValueSlider.vue'
import { onMounted } from 'vue'
import { useBackground, BackgroundThemes } from '../composables/useBackground'

const { exercises, work, rest, totalTime, time2Str } = useTimer()
const router = useRouter()
const { backgroundTheme } = useBackground()

function startWorkout () {
  router.push({ name: 'timer' })
}

onMounted(() => {
  backgroundTheme.value = BackgroundThemes.START
})

</script>

<style scoped lang="scss">
  h2 {
    font-size: 3rem;
  }
</style>
